import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import "leaflet/dist/leaflet.css";
import './Map.css';

const Map = () => {
    // const position = [51.505, -0.09];
    
    return (
        <div className='mx-2 mx-sm-5 mx-md-5 mx-lg-5'>
            <h2 className='text-start mb-4'>My Map Location</h2>
            <div>
                <MapContainer center={[24.886436, 91.880722]} zoom={13} scrollWheelZoom={true}>
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Marker position={[51.505, -0.09]}>
                        <Popup>
                            A pretty CSS3 popup. <br /> Easily customizable.
                        </Popup>
                    </Marker>
                </MapContainer>
            </div>
        </div>
    );
};

export default Map;